import { PointOfInterest } from '@/__generated__/graphql';
import { useFeatureFlag } from '@/hooks';
import { abyssColors } from '@/theme/colors';
import { IconButton, Stack } from '@mui/material';
import { Close, Link } from '@mui/icons-material';
import { ReviewStatus } from '../../ReviewStatus';
import { ReviewAction } from '../../ReviewAction';
import { ActionMenu } from '../../ActionMenu';
import { usePoiTemplateFields } from '../../../../hooks/usePoiTemplateFields';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import { CopyImageUrl } from './styles';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { LocationTag } from '@/constants';

type ReviewStatusProps = {
  onClose: () => void;
  currentPoi: PointOfInterest;
};

export const DialogHeader = ({ currentPoi, onClose }: ReviewStatusProps) => {
  const isAITEngineer = useFeatureFlag('ait-engineer');
  const isAPIInspector = useFeatureFlag('api-inspector');
  const { showSnackBar } = useSnackBarMessage({});
  const selectedAssemblyName = useAtomValue(state.selectedAssemblyName);
  const { templateOfSelectedPoi } = usePoiTemplateFields({
    data: currentPoi || ({} as PointOfInterest),
  });

  const handleCopyImageUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('assembly', selectedAssemblyName || '');
    navigator.clipboard.writeText(url.toString());
    showSnackBar('Url copied to clipboard', 'success');
  };

  return (
    <Stack
      direction="row"
      justifyContent="end"
      alignItems="center"
      sx={{ padding: '26px 23px 0 23px' }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <CopyImageUrl
          onClick={handleCopyImageUrl}
          underline="none"
          id={`${LocationTag.ReviewPanelPoiModal}-copy-image-link`}
        >
          <Link sx={{ transform: 'rotate(-45deg)', fontSize: '1.8rem' }} />
          Copy Image Link
        </CopyImageUrl>
        {currentPoi && (
          <>
            {isAITEngineer && (
              <ReviewStatus
                pointOfInterest={currentPoi}
                templateOfSelectedPoi={templateOfSelectedPoi}
                location={LocationTag.ReviewPanelPoiModal}
              />
            )}
            {isAPIInspector && (
              <ReviewAction
                pointOfInterest={currentPoi}
                templateOfSelectedPoi={templateOfSelectedPoi}
                location={LocationTag.ReviewPanelPoiModal}
              />
            )}
            <ActionMenu pointOfInterest={currentPoi} location={LocationTag.ReviewPanelPoiModal} />
          </>
        )}
        <IconButton onClick={onClose} size="small">
          <Close sx={{ color: abyssColors.primary[500] }} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
